export class AppSettingsPendingError extends Error {
	constructor() {
		super('Missing required telemedicine application settings')
		this.name = 'AppSettingsPendingError'
	}
}
